/**
 * Tiny typed event bus for cross-component data invalidation.
 * Used to keep sidebar counters (CVs, applications) in sync when data
 * is mutated from any page (delete, create, etc.) without forcing a
 * full app-wide query/cache refactor.
 */

type DataEvent = 'cvs-changed' | 'applications-changed';

const listeners = new Map<DataEvent, Set<() => void>>();

export function emitDataChanged(event: DataEvent): void {
  listeners.get(event)?.forEach(cb => {
    try {
      cb();
    } catch (err) {
      console.error(`[dataEvents] listener for "${event}" threw:`, err);
    }
  });
}

export function onDataChanged(event: DataEvent, cb: () => void): () => void {
  if (!listeners.has(event)) {
    listeners.set(event, new Set());
  }
  listeners.get(event)!.add(cb);
  return () => {
    listeners.get(event)?.delete(cb);
  };
}
